import React from 'react';

interface ContractSigningRejectionNoticeProps {
  statusText: string;
  helpText?: string | null;
  detailText?: string | null;
  commentLabel: string;
  comment?: string | null;
  variant?: 'warning' | 'danger';
}

export const ContractSigningRejectionNotice: React.FC<
  ContractSigningRejectionNoticeProps
> = ({
  statusText,
  helpText,
  detailText,
  commentLabel,
  comment,
  variant = 'warning'
}) => {
  const trimmedComment = comment?.trim();
  const trimmedHelp = helpText?.trim();
  const trimmedDetail = detailText?.trim();
  const icon = variant === 'danger' ? 'alert-triangle' : 'alert-circle';
  const labelClass = variant === 'danger' ? 'text-danger' : 'text-warning';

  return (
    <div
      className={`alert alert-${variant} d-flex align-items-start mb-4`}
      role="status"
      data-testid="contract-signing-rejection-notice"
    >
      <i className={`feather-${icon} me-3 fs-4 flex-shrink-0 mt-1`}></i>
      <div className="flex-grow-1">
        <strong>{statusText}</strong>
        {trimmedHelp && <p className="mb-2 small mt-1">{trimmedHelp}</p>}
        {trimmedDetail && (
          <div className="small text-muted mt-1">{trimmedDetail}</div>
        )}
        {trimmedComment && (
          <div className={`bg-white border border-${variant} rounded p-3 mt-2`}>
            <small className={`fw-semibold ${labelClass} d-block mb-1`}>
              <i className="feather-message-square me-1"></i>
              {commentLabel}
            </small>
            <div style={{ whiteSpace: 'pre-wrap', fontSize: 14 }}>
              {trimmedComment}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
